import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import CloudUpload from '@material-ui/icons/CloudUpload';
import Close from '@material-ui/icons/Close';
import { DOCUMENT_UPLOAD_MAX_NUM } from 'src/constants/constants';

const UploadPad = ({ dropHandler, acceptedFileTypes, closeHandler, maxSize, numOfFilesUploaded, multiple, multiSelectExceeded }) => (
  <Dropzone
    className="attachment"
    onDrop={dropHandler}
    accept={acceptedFileTypes}
    maxSize={maxSize}
    disabled={numOfFilesUploaded >= DOCUMENT_UPLOAD_MAX_NUM}
    multiple={multiple === undefined || !!multiple}>
    <CloudUpload className="icon" />
    Drag and drop a document or click to browse
    {closeHandler && (
      <nav className="nav-bar">
        <Close className="icon md" onClick={closeHandler} />
      </nav>
    )}
    {numOfFilesUploaded >= DOCUMENT_UPLOAD_MAX_NUM && (
      <div className="filecount-exceed-error">
        <p>
          <strong>Document upload limit reached, a maximum number of {DOCUMENT_UPLOAD_MAX_NUM} documents is allowed</strong>
        </p>
      </div>
    )}
    {multiSelectExceeded && (
      <div className="filecount-exceed-error">
        <p>
          <strong>
            Document upload limit reached in file multi-selection, a maximum number of {DOCUMENT_UPLOAD_MAX_NUM} documents is allowed in
            total.
          </strong>
        </p>
        <p>
          <strong>
            You may pick another {DOCUMENT_UPLOAD_MAX_NUM - numOfFilesUploaded} file(s) to upload. This batch selection result will be
            abandoned.
          </strong>
        </p>
      </div>
    )}
  </Dropzone>
);

UploadPad.propTypes = {
  dropHandler: PropTypes.func.isRequired,
  acceptedFileTypes: PropTypes.string,
  closeHandler: PropTypes.func,
};

export default UploadPad;
